const options = {
  namespaced: true,
  state: {
    border: [
      {
        value: 0,
        label: '无'
      },
      {
        value: 1,
        label: '1px'
      },
      {
        value: 2,
        label: '2px'
      },
      {
        value: 3,
        label: '3px'
      },
      {
        value: 4,
        label: '4px'
      },
      {
        value: 6,
        label: '6px'
      },
      {
        value: 8,
        label: '8px'
      },
      {
        value: 10,
        label: '10px'
      },
      {
        value: 20,
        label: '20px'
      },
      {
        value: 50,
        label: '50px'
      },
      {
        value: 100,
        label: '100px'
      },
      {
        value: 200,
        label: '200px'
      }
    ],
    border_radius: [
      {
        value: 0,
        label: '无'
      },
      {
        value: 1,
        label: '1px'
      },
      {
        value: 2,
        label: '2px'
      },
      {
        value: 4,
        label: '4px'
      },
      {
        value: 6,
        label: '6px'
      },
      {
        value: 8,
        label: '8px'
      },
      {
        value: 12,
        label: '12px'
      },
      {
        value: 16,
        label: '16px'
      },
      {
        value: 20,
        label: '20px'
      },
      {
        value: 30,
        label: '30px'
      },
      {
        value: 40,
        label: '40px'
      },
      {
        value: 50,
        label: '50px'
      }
    ],
    border_style: [
      {
        value: 'solid',
        label: '线条'
      },
      {
        value: 'dotted',
        label: '圆点'
      },
      {
        value: 'dashed',
        label: '线段'
      },
      {
        value: 'double',
        label: '双线'
      }
    ],
    fontFamily: [
      {
        id: 'initial',
        value: 'initial',
        label: '默认'
      },
    //   {
    //     id: '29',
    //     parentId: null,
    //     dicCode: 'fontPack',
    //     dicName: '字体包',
    //     value: 'font-16',
    //     expandValue: 'node',
    //     indexNameCn: '思源黑体-粗体',
    //     indexNameEn: 'NotoSansHans-Bold.otf',
    //     sortNum: null,
    //     remark: null,
    //     createAt: '2021-12-13 15:54:59',
    //     isDelete: 0,
    //     bigJson: null,
    //     label: '思源黑体-粗体',
    //     hasWoffFile: true
    //   },
      {
        id: '30',
        parentId: null,
        dicCode: 'fontPack',
        dicName: '字体包',
        value: 'font-17',
        expandValue: 'node',
        indexNameCn: '思源黑体-纤细',
        indexNameEn: 'NotoSansHans-Light.otf',
        sortNum: null,
        remark: null,
        createAt: '2021-12-13 15:55:01',
        isDelete: 0,
        bigJson: null,
        label: '思源黑体-纤细',
        hasWoffFile: true
      },
    //   {
    //     id: '31',
    //     parentId: null,
    //     dicCode: 'fontPack',
    //     dicName: '字体包',
    //     value: 'font-18',
    //     expandValue: 'node',
    //     indexNameCn: '思源黑体-中等',
    //     indexNameEn: 'NotoSansHans-Medium.otf',
    //     sortNum: null,
    //     remark: null,
    //     createAt: '2021-12-13 15:55:02',
    //     isDelete: 0,
    //     bigJson: null,
    //     label: '思源黑体-中等',
    //     hasWoffFile: true
    //   },
      {
        id: '38',
        parentId: null,
        dicCode: 'fontPack',
        dicName: '字体包',
        value: 'font-25',
        expandValue: 'node',
        indexNameCn: '思源黑体-中细',
        indexNameEn: 'NotoSansHans-Regular.otf',
        sortNum: null,
        remark: null,
        createAt: '2021-12-14 12:00:04',
        isDelete: 0,
        bigJson: null,
        label: '思源黑体-中细',
        hasWoffFile: true
      },
      {
        id: '50',
        value: 'font-37',
        indexNameCn: '庞门正道细线体',
        label: '庞门正道细线体',
        indexNameEn: 'pmzdxxt.ttf',
        parentId: null,
        dicCode: 'fontPack',
        dicName: '字体包',
        expandValue: 'node',
        sortNum: null,
        remark: null,
        createAt: '2022-08-10 17:00:04',
        isDelete: 0,
        bigJson: null,
        hasWoffFile: true
      },
      {
          "id": "56",
          "value": "font-43",
          "indexNameCn": "优设标题圆体",
          "label": "优设标题圆体",
          "indexNameEn": "ysbty.ttf" ,
          "parentId": null,
          "dicCode": "fontPack",
          "dicName": "字体包",
          "expandValue": "node",
          "sortNum": null,
          "remark": null,
          "createAt": "2022-08-10 17:00:04",
          "isDelete": 0,
          "bigJson": null,
          "hasWoffFile": true
      },
    ],
    fontSize: [
      { label: '12px', value: 12 },
      { label: '14px', value: 14 },
      { label: '16px', value: 16 },
      { label: '18px', value: 18 },
      { label: '20px', value: 20 },
      { label: '24px', value: 24 },
      { label: '32px', value: 32 },
      { label: '48px', value: 48 },
      { label: '84px', value: 84 },
      { label: '96px', value: 96 },
      { label: '128px', value: 128 }
    ],
    line_height: [
      { label: '12px', value: 12 },
      { label: '14px', value: 14 },
      { label: '16px', value: 16 },
      { label: '18px', value: 18 },
      { label: '20px', value: 20 },
      { label: '24px', value: 24 },
      { label: '32px', value: 32 },
      { label: '48px', value: 48 },
      { label: '64px', value: 64 },
      { label: '96px', value: 96 },
      { label: '128px', value: 128 }
    ],
    fieldType: [
      {
        label: '姓名',
        value: 'name',
        rules: /^[\u0391-\uFFE5A-Za-z]+$/
      },
      {
        label: '手机',
        value: 'tel',
        rules: /^1\d{10}$/
      },
      {
        label: '邮箱',
        value: 'email',
        rules: /^([a-zA-Z\d])(\w|\-)+@[a-zA-Z\d]+\.[a-zA-Z]{2,4}$/
      },
      {
        label: '文本',
        value: 'text',
        rules: /\*/
      }
    ],
    dateFormat: [
      {
        label: 'xx年xx月xx日',
        value: 'text'
      },
      {
        label: 'xx.xx.xx',
        value: '.'
      },
      {
        label: 'xx/xx/xx',
        value: '/'
      },
      {
        label: 'xx-xx-xx',
        value: '-'
      }
    ],
    dateType: [
      {
        label: '年-月-日',
        value: 'd'
      },
      //    {
      //        label:'星期',
      //        value:'w'
      //    },
      {
        label: '年-月-日 星期',
        value: 'dw'
      }
    ],
    shadowX: [
      {
        value: -8,
        label: '-8px'
      },
      {
        value: -4,
        label: '-4px'
      },
      {
        value: -2,
        label: '-2px'
      },
      {
        value: 0,
        label: '0px'
      },
      {
        value: 2,
        label: '2px'
      },
      {
        value: 4,
        label: '4px'
      },
      {
        value: 8,
        label: '8px'
      },
      {
        value: 10,
        label: '10px'
      }
    ],
    shadowY: [
      {
        value: -8,
        label: '-8px'
      },
      {
        value: -4,
        label: '-4px'
      },
      {
        value: -2,
        label: '-2px'
      },
      {
        value: 0,
        label: '0px'
      },
      {
        value: 2,
        label: '2px'
      },
      {
        value: 4,
        label: '4px'
      },
      {
        value: 8,
        label: '8px'
      },
      {
        value: 10,
        label: '10px'
      }
    ],
    shadowBlur: [
      {
        value: 0,
        label: '0px'
      },
      {
        value: 2,
        label: '2px'
      },
      {
        value: 4,
        label: '4px'
      },
      {
        value: 8,
        label: '8px'
      },
      {
        value: 12,
        label: '12px'
      },
      {
        value: 20,
        label: '20px'
      }
    ],
    positionInfo: [
      {
        label: '招聘类别',
        value: 'category',
        text: '默认类别',
        sort: 1
      },
      {
        label: '工作性质',
        value: 'nature',
        text: '全职',
        sort: 2
      },
      {
        label: '工作地点',
        value: 'location',
        text: '全国',
        sort: 3
      },
      {
        label: '需求部门',
        value: 'department',
        text: '默认部门',
        sort: 4
      },
      {
        label: '招聘人数',
        value: 'peopleNumber',
        text: '在招若干人',
        sort: 5
      },
      {
        label: '面试站点',
        value: 'site',
        text: '面试站点：北京大学站',
        sort: 6
      },
      {
        label: '薪资范围',
        value: 'salary',
        text: '500W-1000W/年',
        sort: 7
      },
      {
        label: '工作经验',
        value: 'experience',
        text: '1年以上',
        sort: 8
      },
      {
        label: '学历要求',
        value: 'education',
        text: '本科',
        sort: 9
      },
      {
        label: '招聘负责人',
        value: 'head',
        text: 'HR小张.招聘负责人',
        sort: 9
      }
    ],
    textList: [
      {
        label: '企业简称',
        value: 'companyName'
      },
      {
        label: '门户名称',
        value: 'gatewayName'
      },
      {
        label: '用户名称',
        value: 'userName'
      },
      {
        label: '系统预置职位',
        value: 'positionName'
      },
      {
        label: '职位信息',
        value: 'positionInfo'
      },
      {
        label: '系统预置活动',
        value: 'activityName'
      }, {
        label: '活动介绍',
        value: 'activityInfo'
      }
    ],
    sendList: [
      {
        name: '标准简历',
        value: '1',
        selected: true
      },
      {
        name: '隐藏信息',
        value: '2',
        selected: false
      },
      {
        name: '原始简历',
        value: '3',
        selected: true
      },
      {
        name: '测评报告',
        value: '5',
        selected: true
      },
      {
        name: '筛选结果',
        value: '6',
        selected: true
      },
      {
        name: '面试评价',
        value: '7',
        selected: true
      },
      {
        name: '附加资料',
        value: '4',
        selected: true
      },
      {
        name: '培训记录',
        value: '10',
        selected: true
      },
      {
        name: '跟进记录',
        value: '12',
        selected: true
      },
      {
        name: '背调',
        value: '9',
        selected: false
      },
      {
        name: 'Offer',
        value: '11',
        selected: false
      },      
      {
        name: '招聘记录',
        value: '13',
        selected: false
      }
    ],
  },
  mutations: {
    set_option(state, val) {
      state[val.key] = val.value
    }
  }
}

export default options
